import { motion } from "motion/react";

export function Footer() {
  return (
    <motion.footer
      className="border-white/10 border-t bg-background/30"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-5 py-3 text-[11px] text-foreground/50">
        <p>reify-land.ofoz.net</p>
        <p>Downloads and documentation for reify.</p>
      </div>
    </motion.footer>
  );
}
